module.exports = "/assets/9fad4da39a0cfb0d582b90ba935be568.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/KK.png
// module id = 1548
// module chunks = 0